"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
function VideoFilterContent(_a) {
    var channelId = _a.channelId, setVideo = _a.setVideo, closeModal = _a.closeModal;
    return (react_1.default.createElement("div", { className: 'overflow-y-scroll storybook-analytics-filter-modal' },
        react_1.default.createElement(storybook_1.Texts.Primary, { appendClassname: 'pb-4 text-center font-medium' }, "Filter op de naam van je video"),
        react_1.default.createElement(storybook_1.Forms.Search, { searchParams: {
                channel_id: channelId,
                resource: 'VideoFull',
                sort: 'created_at desc',
                details: true,
                type: ['vod', 'event'],
                tags: true
            }, onClick: function (video) {
                setVideo(video);
                closeModal();
            }, autoFocus: true })));
}
function VideoFilter(_a) {
    var video = _a.video, setVideo = _a.setVideo, channelId = _a.channelId;
    var _b = storybook_1.Hooks.useModal(), Modal = _b[0], setModal = _b[1], closeModal = _b[2];
    function openModal() {
        setModal({
            content: function () { return react_1.default.createElement(VideoFilterContent, { channelId: channelId, setVideo: setVideo, closeModal: closeModal }); }
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Modal, null),
        react_1.default.createElement("div", { className: 'storybook-analytics-video-filter' }, video.id ? react_1.default.createElement(storybook_1.Buttons.Button, { onClick: function () { return setVideo({ id: null }); }, type: 'light', icon: 'x', outline: true }, video.title)
            : react_1.default.createElement(storybook_1.Buttons.Button, { onClick: openModal, type: 'light', outline: true }, "Filter op video"))));
}
exports.default = VideoFilter;
